import { useState } from "react";
import { useLanguageStore, type Language } from "../store/languageStore";
import { Globe } from "lucide-react";

export const LanguageToggle = () => {
  const { selectedLanguage, setLanguage } = useLanguageStore();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: "EN" as Language, name: "English" },
    { code: "ES" as Language, name: "Español" },
    { code: "ZH" as Language, name: "中文" },
    { code: "VI" as Language, name: "Tiếng Việt" },
    { code: "FIL" as Language, name: "Filipino" },
    { code: "KO" as Language, name: "한국어" },
    { code: "AR" as Language, name: "العربية" },
  ];

  const handleLanguageChange = (langCode: Language) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 dark:focus:ring-teal-400 rounded-lg transition-colors"
        aria-label="Select language"
      >
        <Globe className="w-4 h-4" />
        <span>{languages.find(lang => lang.code === selectedLanguage)?.name || "Language"}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`${
                  selectedLanguage === language.code
                    ? "bg-teal-50 dark:bg-teal-900/20 text-teal-600 dark:text-teal-400"
                    : "text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                } block w-full text-left px-4 py-2 text-sm`}
                role="menuitem"
              >
                {language.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};